import React from 'react';
import axios from 'axios';
import './AlertsTable.css';
import timeFromMilitary from '../functions/timeFromMilitary';

const AlertsTable = ({ alerts = [], loading = false, fetchAlerts = null, getAccessTokenSilently = null }) => {

  const handleDelete = async (id) => {
    try {
      const token = await getAccessTokenSilently();
      const response = await axios.delete(`/api/alerts/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
    });
      
      // If deletion was successful, refresh the alerts list
      if (response.data && response.data.success) {        
        if (fetchAlerts && typeof fetchAlerts === 'function') {
          fetchAlerts();
        }
      }
    } catch (err) {
      console.error(`Error deleting alert ${id}:`, err);
      alert(`Failed to delete alert: ${err.response?.data?.error || err.message}`);
    }
  };
  
  return (
    <div className="alert-form-container">
      <div className="alert-form">
        <h2>Active Alerts</h2>

        {loading ? (
          <div className="message message-success">Loading alerts...</div>
        ) : alerts.length === 0 ? (
          <div className="message message-error">No active alerts found.</div>
        ) : (
          <div className="alerts-wrapper">
            <table className="alerts-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Depart</th>
                  <th>Arrive</th>
                  <th>Date</th>
                  <th>Max $</th>
                  <th>Earliest</th>
                  <th>Latest</th>
                  <th>Phone</th>
                  <th aria-hidden="true"> </th>
                </tr>
              </thead>
              <tbody>
                {alerts.map((a) => (
                  <tr key={a[0]}>
                    <td>{a[0]}</td>
                    <td>{a[1]}</td>
                    <td>{a[2]}</td>
                    <td>{a[3]}</td>
                    <td>${a[4]}</td>
                    <td>{timeFromMilitary(a[5])}</td>
                    <td>{timeFromMilitary(a[6])}</td>
                    <td>{a[7]}</td>
                    <td>
                      <button
                        className="delete-button"
                        onClick={() => {
                          if (window.confirm(`Are you sure you want to delete alert ${a[0]} from ${a[1]} to ${a[2]}?`)) {
                            handleDelete(a[0]);
                          }
                        }}
                        title="Delete alert"
                        aria-label={`Delete alert ${a[0]}`}
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default AlertsTable;
